// extracted by mini-css-extract-plugin
var _1 = "DiscardSectionChangesModalContent-module__animatedBackground--lv_6P";
var _2 = "DiscardSectionChangesModalContent-module__container--CGGGG";
var _3 = "DiscardSectionChangesModalContent-module__footer--pdzSG";
var _4 = "DiscardSectionChangesModalContent-module__message--HTLm4";
var _5 = "DiscardSectionChangesModalContent-module__sectionName--Jbz6M";
var _6 = "DiscardSectionChangesModalContent-module__sectionRow--CL5EZ";
var _7 = "DiscardSectionChangesModalContent-module__sectionRowContainer--E9ukT";
export { _1 as "animatedBackground", _2 as "container", _3 as "footer", _4 as "message", _5 as "sectionName", _6 as "sectionRow", _7 as "sectionRowContainer" }
